import {ANALYTIC_EVENTS} from './pub-sub/constants';
import {publishEvent} from './pub-sub';

const betWidgetCallback = entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      publishEvent(ANALYTIC_EVENTS.PM_WIDGET_IMPRESSION);
    }
  });
};

const observeWidget = ({
  observer,
  $element
}) => {
  if (!observer || !$element) {
    return;
  }

  observer.observe($element);
};

export {observeWidget, betWidgetCallback};
